'use client'
import { createContext, useContext } from "react";
const TableBodyContext = /*#__PURE__*/ createContext({});
const useTableBodyContext = ()=>useContext(TableBodyContext);
export { TableBodyContext, useTableBodyContext };
